export default __webpack_public_path__ + "static/media/acceptworkorder.c009f133.svg";